export default __webpack_public_path__ + "static/logo_footer-b9000f82cba5edb023cc180b05fb2061.svg";